import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MasterService } from '../services/master-service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';


@Component({
  templateUrl: '../main.component.html'
})

export class CommissionPlanListComponent implements OnInit {
  public menuName = "Master";
  public titleName = "Commission Plan";
  public clickOpen = "Rowdoubleclick($event)";
  //public rowscount = 0;
  public edited = true;
  public isSearchDate = false;
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  first_flg: boolean = true;
  loading_flg: boolean = true;

  //get source
  constructor(private _masterService: MasterService, private _router: Router, public dialog: MatDialog, private _com: CommonService) {
  }

  ngOnInit() {
    this.getItemsDropDown();
    this.getPaymentsDropDown();
    this.getCommissionPlans();
  }

  getCommissionPlans() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    
    this._masterService.getCommissionPlans(false).subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  getItemsDropDown() {
    this._masterService.getItemsForDropDown().subscribe((data) => {
      this.itemsSource.localdata = data;
    });
  }

  getPaymentsDropDown() {
    this._masterService.getPaymentsForDropDown().subscribe((data) => {
      this.paymentsSource.localdata = data;
    });
  }

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let id = this.myGrid.getrowdata(selectedrowindex).commission_plan_id;
    let dialogRef = this.dialog.open(PopupCommissionPlanComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        commission_plan_id: id
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getCommissionPlans();
      });
  }

  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }
  dropDownSource: string[] = ['Id', 'Payment', 'Item', 'Price', 'Inactive'];

  groups: any[] = ['item_name'];
  getPagesize(): any {
    return 20;
  }
  //grid 
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'commission_plan_id', type: 'int' },
        { name: 'payment_id', type: 'int' },
        { name: 'payment_type', type: 'string' },
        { name: 'item_id', type: 'int' },
        { name: 'item_name', type: 'string' },
        { name: 'price', type: 'float', cellsformat: 'c2' },
        { name: 'remarks', type: 'string' },
        { name: 'inactive', type: 'bool' }
      ],
      id: 'commission_plan_id',
      localdata: {},
      sortcolumn: 'item_name'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  paymentsSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'payment_id', type: 'int' },
        { name: 'payment_type', type: 'string' }
      ],
      localdata: {}
    };
  paymentsAdapter: any = new jqx.dataAdapter(this.paymentsSource, { autoBind: true });

  itemsSource: any =
    {
      //datatype: 'array',
      datatype: 'array',
      datafields: [
        { name: 'item_id', type: 'int' },
        { name: 'item_name', type: 'string' }
      ],
      localdata: {}
    };
  itemsAdapter: any = new jqx.dataAdapter(this.itemsSource, { autoBind: true });

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return false;
  }
  //columns
  columns: any[] =
    [
      { text: 'Id', datafield: 'commission_plan_id', width: '10%', align: 'right', cellsalign: 'right', columntype: 'textbox', editable: false },
      {
        text: 'Payment', datafield: 'payment_id', displayfield: 'payment_type', width: '20%', columntype: 'dropdownlist', editable: false,
        createeditor: (row: number, column: any, editor: any): void => {
          // assign a new data source to the dropdownlist.
          //let list = ['Admin', 'Super AgentPerson', 'General AgentPerson'];
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.paymentsAdapter, valueMember: 'payment_id', displayMember: 'payment_type', editable: false });
        },
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'Payment is required' };
          }
          return true;
        }
      },
      {
        text: 'Item', datafield: 'item_id', displayfield: 'item_name', width: '20%', columntype: 'dropdownlist', editable: false,
        createeditor: (row: number, column: any, editor: any): void => {
          // assign a new data source to the dropdownlist.
          //let list = ['Admin', 'Super AgentPerson', 'General AgentPerson'];
          editor.jqxDropDownList({ autoDropDownHeight: true, source: this.itemsAdapter, valueMember: 'item_id', displayMember: 'item_name' });
        },
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'Item is required' };
          }
          return true;
        }
      },
      {
        text: 'Price', datafield: 'price', width: '10%', cellsalign: 'right', cellsformat: 'c2', columntype: 'numberinput', editable: false,
        initeditor: function (row, cellvalue, editor) {
          editor.jqxNumberInput({ digits: 5 });
        },
        validation: (cell: any, value: any): any => {
          var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;
          if (value == '') {
            return { result: false, message: 'Price is required.' };
          } else if (!(pattern.test(value))) {
            return { result: false, message: 'Please input only decimal for Price.' };
          } else if (!(parseFloat(value) > 0)) {
            return { result: false, message: 'Price must be more than 0' };
          }else if (value.length > 100) {
            return { result: false, message: 'Price must be less than 100 letters.' };
          }
          return true;
        }
      },
      {
        text: 'Remarks', datafield: 'remarks', width: '30%', columntype: 'custom', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 200) {
            return { result: false, message: 'Remarks Code must be less than 200 letters.' };
          }
          return true;
        }
      },
      { text: 'Inactive', datafield: 'inactive', width: '10%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false }
    ];

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  //generatedata(): any {
  //  let row = {};
  //  row['commission_plan_id'] = 0;
  //  row['payment_id'] = 1;
  //  row['payment_type'] = "一括";
  //  row['item_name'] = "";
  //  row['price'] = 0;
  //  row['inactive'] = false;

  //  return row;
  //}

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    //saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
    //deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    //saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
    //buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    //buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    //// add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupCommissionPlanComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          commission_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getCommissionPlans();
        });
    });
    //addButton.addEventHandler('click', (event: any): void => {
    //  let datarow = this.generatedata();
    //  this.myGrid.addrow(null, datarow);
    //});
    //// delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getCommissionPlans();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    //// save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  for (var i = 0; i < this.myGrid.getrows().length; i++) {
    //    let commission_plan = this.myGrid.getrowdata(i);
    //    if (commission_plan.payment_id == 0
    //      || commission_plan.item_id == 0
    //      || commission_plan.price <= 0
    //      || commission_plan.price > 100
    //      || commission_plan.price.length <= 0) {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }

    //  let rows = this.myGrid.getrows();

    //  rows.forEach(commission_plan => {
    //    if (commission_plan.commission_plan_id == 0) {
    //      this._masterService.addCommissionPlan(commission_plan)
    //        .subscribe(
    //        data => {
    //          //this.getCommissionPlans();
    //          let index = this.myGrid.getrowboundindexbyid(commission_plan.commission_plan_id);
    //          commission_plan.commission_plan_id = data;
    //          this.myGrid.setcellvalue(index, "commission_plan_id", data);
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //    else {
    //      this._masterService.updateCommissionPlan(commission_plan)
    //        .subscribe(
    //          data => {
    //          //this.getCommissionPlans();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) { 
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows.forEach(commission_planId => {
    //    if (commission_planId != 0) {
    //      this._masterService.deleteCommissionPlan(commission_planId).subscribe(
    //          data => {
    //            //this.getCommissionPlans();
    //            if (data != 1) {
    //              this.errorMessage += "Data has not been found : ID " + commission_planId;
    //            }
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;
    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'commission_plan_id';
        break;
      case 1:
        datafield = 'payment_type';
        break;
      case 2:
        datafield = 'item_name';
        break;
      case 3:
        datafield = 'price';
        break;
      case 4:
        datafield = 'remarks';
        break;
      case 5:
        datafield = 'inactive';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  btnOnClick() {
    let gridContent = this.myGrid.exportdata('html');
    let newWindow = window.open('', '', 'width=800, height=500'),
      document = newWindow.document.open(),
      pageContent =
        '<!DOCTYPE html>\n' +
        '<html>\n' +
        '<head>\n' +
        '<meta charset="utf-8" />\n' +
        '<title>CommissionPlan - Report</title>\n' +
        '</head>\n' +
        '<body>\n' + gridContent + '\n</body>\n</html>';
    document.write(pageContent);
    document.close();
    newWindow.print();
  };

  //export excel
  excelBtnOnClick() {
    this.myGrid.exportdata('xls', 'CommissionPlan');
  };

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}


//****************************************************
// Popup
//****************************************************

@Component({
  selector: 'app-popup-commission-plan',
  templateUrl: 'popup-commission-plan.component.html',
  styleUrls: ['./master-popup.component.css'],
})
export class PopupCommissionPlanComponent implements OnInit {
  title: string = "(Create)";
  Form: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  paymentList: Array<any> = [];
  itemList: Array<any> = [];
  user: any;

  constructor(
    public dialogRef: MatDialogRef<PopupCommissionPlanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.Form = this._fb.group({
      commission_plan_id: 0,
      payment_id: 0,
      payment_type: ['', Validators.required],
      item_id: 0,
      item_name: ['', Validators.required],
      price: [0, Validators.required],
      remarks: '',
      updated_by: this.user,
      updated_date: todayStr,
      inactive: false
    })
  }

  ngOnInit() {
    this.getCommissionPlanById(this.data.commission_plan_id);
    this.getDropDownList();
  }

  ngAfterViewInit(): void {
  }

  getDropDownList() {
    //Item
    this._masterService.getPayments(true)
      .subscribe(data => {
        this.paymentList = data;
      });
    //Term
    this._masterService.getItems(true)
      .subscribe(data => {
        this.itemList = data;
      });
  }
  getCommissionPlanById(id) {
    if (id > 0) {
      this.title = '(Edit/View)'
      this._masterService.getCommissionPlanById(id)
        .subscribe(
          res => {
            this.Form.setValue(res);
          },
          error => this.errorMessage = error._body
        );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '70%';
  }

  //Save Data
  saveCommissionPlan() {
    //check form
    if (this.Form.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.Form.value.updated_by = this.user;
    this.Form.value.updated_date = todayStr;
    if (this.commission_plan_id.value == 0) {
      this._masterService.addCommissionPlan(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully added the data.";
              this.getCommissionPlanById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
    }
    else {
      this._masterService.updateCommissionPlan(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getCommissionPlanById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to update the data. ";
            }
          });
    }
  }

  //Delete Data
  deleteCommissionPlan() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.commission_plan_id.value != 0) {

      let id = this.commission_plan_id.value;

      this._masterService.deleteCommissionPlan(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  paymentOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getPaymentById(value)
        .subscribe(
          data => {
            this.payment_type.setValue(data.description);
          });
    }
    else {
      this.payment_type.setValue(null);
    }
  }

  itemOnSelect(event: any): void {
    let value = event.value;
    if (value > 0) {
      this._masterService.getItemById(value)
        .subscribe(
          data => {
            this.item_name.setValue(data.description);
          });
    }
    else {
      this.item_name.setValue(null);
    }
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get commission_plan_id() { return this.Form.get('commission_plan_id'); }
  get payment_id() { return this.Form.get('payment_id'); }
  get payment_type() { return this.Form.get('payment_type'); }
  get item_id() { return this.Form.get('item_id'); }
  get item_name() { return this.Form.get('item_name'); }
  get price() { return this.Form.get('price'); }
  get remarks() { return this.Form.get('remarks'); }
  get inactive() { return this.Form.get('inactive'); }
  get updated_by() { return this.Form.get('updated_by'); }
  get updated_date() { return this.Form.get('updated_date'); }
}



// WEBPACK FOOTER //
// ./src/app/master/commission-plan-list.component.ts